import { Colis } from "@/interfaces/Return";
import React from "react";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "../ui/accordion";
import Product from "../product/Product";
import { cn } from "@/lib/utils";
import { Package } from "lucide-react";

interface ScannedColisProps {
  colis: Colis;
  isScanned: boolean;
}

const ScannedColis: React.FC<ScannedColisProps> = ({ colis, isScanned }) => {
  return (
    <Accordion type="single" collapsible className={cn("w-full")}>
      <AccordionItem className="border rounded-lg mb-2" value="item">
        <AccordionTrigger
          className={`hover:no-underline py-4 px-3 transition-all duration-300 ease-in-out font-medium ${
            isScanned
              ? "bg-gradient-to-r from-emerald-100 to-teal-100 hover:from-emerald-100 hover:to-teal-100"
              : "hover:bg-muted/30 data-[state=open]:bg-muted/50"
          }`}
        >
          <div className="flex items-center justify-between flex-1 gap-2">
            <div className="flex items-center">
              <Package className="w-6 h-6 mr-2" />
              <span>Colis N° {colis.colisCode}</span>
            </div>
            <span className="text-sm text-muted-foreground mr-2">
              {colis.articles.length} articles
            </span>
          </div>
        </AccordionTrigger>
        <AccordionContent className="px-3">
          {colis.articles.map((article) => (
            <Product product={article} />
          ))}
        </AccordionContent>
      </AccordionItem>
    </Accordion>
  );
};

export default ScannedColis;
